import React, { useContext } from 'react';
import { Card, CardContent, CardMedia, Typography, Grid, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import NumberInput from '../NumberInput';
import { CartItemProps } from '../../models/product';
import { ProductContext } from '../../context/products-context';

const CartItem = (props: CartItemProps) => {
  const {
    name,
    price,
    images,
    quantity
  } = props;

  const mainImage = images[0];

  const { removeFromCart, setCartQuantity } = useContext(ProductContext);

  const handleIncrement = (event: React.FocusEvent | React.PointerEvent | React.KeyboardEvent, value: number | null) => {
    setCartQuantity(name, value);
  };

  return (
    <Card sx={{ m: 2, boxShadow: 0 }}>
      <CardContent sx={{ p: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid size={2}>
            <CardMedia
              component="img"
              alt={name}
              src={mainImage}
              sx={{
                borderRadius: '10%',
                width: '100%',
                height: 'auto',
                aspectRatio: '1 / 1',
                objectFit: 'cover',
              }}
            />
          </Grid>
          <Grid size={3} sx={{ px: 2 }}>
            <Typography fontSize={22} variant="subtitle1" fontWeight={600}>
              {name}
            </Typography>
          </Grid>
          <Grid size={1} sx={{ pr: 2 }}>
            <Typography fontSize={22} variant="subtitle1">
              R{price}
            </Typography>
          </Grid>
          <Grid size={3} sx={{ display: 'flex', justifyContent: 'center' }}>
            <NumberInput
              value={quantity}
              onChange={handleIncrement}
              min={1}
              max={100}
            />
          </Grid>
          <Grid size={2} sx={{ pl: 2 }}>
            <Typography fontSize={22} variant="subtitle1" fontWeight={600}>
              R{price * quantity}
            </Typography>
          </Grid>
          <Grid size={1} container justifyContent="end" sx={{ pr: 0.5 }}>
            <IconButton aria-label="remove" color="default" onClick={() => removeFromCart(name, quantity)}>
              <ClearIcon />
            </IconButton>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CartItem;